module.exports = __webpack_public_path__ + "static/img/peopleGame2.7310e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/peopleGame2.png
// module id = qInv
// module chunks = 3